import { makeObservable, action, observable } from 'mobx';
import { StoreMeta } from '../FormStore';
import { set, get, cloneDeep } from 'lodash'
import { BaseField, Field } from '../field';
import { runInAction } from 'mobx';
export interface ValueObj {
  [key: string]: string | number | ValueObj
}

type SetValueOptions = {
  characterId?: string
}

/**
 * 用数据源生成的记录数据的store
 **/
export class FormData {
  data: {
    [key: string]: string | number | boolean | ValueObj | ValueObj[]
  }
  dirtyData: {
    [key: string]: string | number | boolean | ValueObj | ValueObj[]
  }
  fields?: Map<string, Field>
  hooks?: any
  constructor(_storeMeta?: StoreMeta) {
    this.data = observable.object({}, { deep: true })
    this.dirtyData = {}
    makeObservable(this, {
      setValue: action.bound
    })
  }

  /**
 * 表单赋值, 调用field的setValue方法
 * @function setValue
 * @param {ValueObj} value
 */

  setValue(fieldAlias: string | ValueObj, value?: ValueObj | ValueObj[] | string | number | null, _options?: SetValueOptions) {
    if (!fieldAlias) {
      throw new Error('setValue 的 key 不能为空')
    }
    if (typeof fieldAlias === 'string') {
      const field = this.getFieldAndCreate(fieldAlias)
      this.setValueByField(field, fieldAlias, value);
    }
    if (typeof fieldAlias === 'object') {
      // form整体赋值
      // TODO: 整体覆盖 or 增量
      const formValue = fieldAlias
      runInAction(() => {
        for (const dataKey in formValue) {
          const field = this.getFieldAndCreate(dataKey) //this.fields?.get(dataKey)
          this.setValueByField(field, dataKey, formValue[dataKey]);
        }
      })
      this.hooks?.afterSetValue?.(this.data)
    }
  }

  getFieldAndCreate(key: any) {
    const field = this.fields?.get(key)
    return field
  }

  /**
   * 根据 field 对象的类型设置数据到 data
   * @param field
   * @param fieldAlias
   * @param value
   */
  private setValueByField(field: Field | undefined, fieldAlias: string, value: any) {
    if (field?.getField()) {
      field.setValue(value)
      return
    }
    const key = fieldAlias;
    this.setTrueValue(key, value, field?.isCharacter())
  }

  /**
    * 设置真实值
    * @param key 保存key
    * @param value 保存value
    * @param isTree a.b 是否对象穿透
    */
  setTrueValue(key: string, value: any, isTree?: boolean) {
    if (isTree) {
      set(this.data, key, value)
    } else {
      this.data[key] = value
    }
  }

  /*
   * 表单取值, 调用field的getValue方法
   * @function getValue
   * @param {string} fieldAlias 需要获取的字段，不传时返回所有值
   * @return {ValueObj} value
   */

  getValue(fieldAlias?: string) {
    if (fieldAlias) {
      const field = this.fields?.get(fieldAlias)
      return field ? field.getValue() : get(this.data, fieldAlias)
    }
    let data: any = {}
    this.fields?.forEach((baseField: BaseField) => {
      const key = baseField.getField()
      if (baseField.isCharacter()) {
        set(data, key, cloneDeep(baseField.getValue()))
      } else {
        data[key] = cloneDeep(baseField.getValue())
      }
    })
    return { ...cloneDeep(this.data), ...data }
  }

  /**
   * 获取真实的值
   * @param key key
   * @returns
   */
  getTrueValue(key: string) {
    return get(this.data, key);
  }


  /**
   * 将接口数据存入store
   * @param value
   */
  setEntityValue(value: ValueObj) {
    if (typeof value === 'object') {
      runInAction(() => {
        for (const dataKey in value) {
          this.setTrueValue(dataKey, value[dataKey])
        }
      })
    }
    this.hooks?.afterSetValue?.(this.data)
  }

  /**
   * 取出接口所需数据
   * @returns entityValue
   */
  getEntityValue() {
    const entityValue: { [key: string]: ValueObj | string | number } = {}
    this.fields?.forEach((field, fieldAlias) => {
      // @ts-ignore
      const alias = field.dataSourceAlias || fieldAlias
      // @ts-ignore
      const entityKey = field.dataSourceAlias || field.field || fieldAlias
      const value = get(this.data, alias)
      entityValue[entityKey] = value
    })
    return entityValue
  }

  trimValue(data: ValueObj) {
    const trim = (data: ValueObj) => {
      const res: ValueObj = {}
      for (const fieldAlias in data) {
        const fieldValue: any = data[fieldAlias]
        if (Object.prototype.toString.call(fieldValue) === '[object Object]') {
          res[fieldAlias] = trim(fieldValue)
        } else if (fieldValue?.toString()) {
          res[fieldAlias] = fieldValue
        }
      }
      return res
    }
    return trim(data)
  }
}
